module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAiCAYAAAD7wEFuAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAy0lEQVRYhe3ZUW3DMBQF0JMo/yuEQRiDFkIhbAwCYRTKYEOwQuiYdAwWBG8fzhjUsvzkI1n5vVdRLF1ligh4wVkOd3zAFBFnfLVMU8E3TlNE3HBsHKaGaVZeYzYbLFhx2E8WK+Wbax2kmrl1gJpGuV6Ncr0a5XqVutyyP5/3k8WNUi7jKvjEa/pV8Ns6RQUb5UJZlXGXxWasgs6Ncr0a5Xo1yvUqdbn/VXBQ/hdkcN+PBSdc8dQszuNdsI5V0KsZ7/hpnOPR3ki+Cv4AGoMwJQ4PHBUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/component/header/images/icon_burgerMenu4.png
// module id = 358
// module chunks = 4